import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import config from '../../config';
import request from 'superagent';

export function* getSponsors() {
    yield* takeEvery("SPONSORS/FETCH", function* (action) {
        try {
            const result = yield call(({ id }) => {
                return request.get(`${config.apiEndpoint}/api/cs/v2/sponsors${id ? `/${id}` : ''}`)
                    .set('Authorization', `Bearer ${config.apiKey}`)
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { sponsors, sponsor } = result;
                if (action.id) {
                    yield put({ type: 'SPONSOR/SET', sponsor });
                } else {
                    yield put({ type: 'SPONSORS/SET', sponsors });
                }
            } else {
                yield put({
                    type: 'SPONSORS/FETCH_FAILED',
                    result
                });
            }
        } catch (e) {
            yield put({
                type: 'SPONSORS/FETCH_FAILED',
                e
            });
        }
    });
}


// WEBPACK FOOTER //
// ./src/redux-sagas/sagas/sponsors.js